import pdfMake from "@digicole/pdfmake-rtl/build/pdfmake";
import pdfFonts from "@digicole/pdfmake-rtl/build/vfs_fonts";
import iransans from "../../assets/fonts/vazir/Farsi-Digits/Vazir-Light-FD.ttf";
import { numberFormatter } from "../Number/numberFormatter";
import momentJalai from "moment-jalaali";

var fontLoaded = false;

var loadFont = function () {
  if (fontLoaded) return Promise.resolve();
  pdfMake.vfs = pdfFonts;
  return fetch(iransans)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      var base64 = btoa(
        new Uint8Array(buf).reduce(function (data, byte) {
          return data + String.fromCharCode(byte);
        }, "")
      );
      pdfMake.vfs["IRANSansWeb.ttf"] = base64;
      pdfMake.fonts = {
        IRANSans: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
        Nillima: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
        Roboto: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
      };
      fontLoaded = true;
    });
};

function getStatusText(status) {
  if (status === "paid") return "پرداخت شده";
  if (status === "unpaid") return "پرداخت نشده";
  if (status === "partial") return "پرداخت جزئی";
  return status || "-";
}

function getTypeText(type) {
  if (type === "debit") return "بدهی";
  if (type === "credit") return "طلب";
  return type || "-";
}

export var generateDebitCreditPdf = function (data) {
  loadFont().then(function () {
    var docDefinition = {
      defaultStyle: {
        font: "IRANSans",
        fontSize: 11,
      },
      pageMargins: [30, 30, 30, 30],
      content: [
        {
          text: "اطلاعات بدهی یا طلب شماره " + (data.id || ""),
          style: "title",
          alignment: "center",
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            widths: ["*", "*"],
            body: [
              [
                { text: "نوع", style: "label" },
                { text: getTypeText(data.type), alignment: "center" },
              ],
              [
                { text: "مبلغ", style: "label" },
                { text: numberFormatter(data.amount), alignment: "center" },
              ],
              [
                { text: "باقیمانده", style: "label" },
                { text: numberFormatter(data.remained), alignment: "center" },
              ],
              [
                { text: "تاریخ", style: "label" },
                { text: data.date_fa || "-", alignment: "center" },
              ],
              [
                { text: "طرف حساب", style: "label" },
                { text: data.user_fullname || "-", alignment: "center" },
              ],
              [
                { text: "وضعیت", style: "label" },
                { text: getStatusText(data.status), alignment: "center" },
              ],
              [
                { text: "بابت", style: "label" },
                { text: data.about || "-", alignment: "center" },
              ],
              [
                { text: "تاریخ تسویه", style: "label" },
                { text: data.cleared_at_fa || "-", alignment: "center" },
              ],
              [
                { text: "توضیحات", style: "label" },
                { text: data.description || "-", alignment: "center" },
              ],
            ],
          },
          layout: {
            hLineWidth: function () {
              return 0.5;
            },
            vLineWidth: function () {
              return 0.5;
            },
            hLineColor: function () {
              return "#cccccc";
            },
            vLineColor: function () {
              return "#cccccc";
            },
            fillColor: function (rowIndex) {
              return rowIndex % 2 === 0 ? "#f5f5f5" : null;
            },
            paddingLeft: function () {
              return 8;
            },
            paddingRight: function () {
              return 8;
            },
            paddingTop: function () {
              return 4;
            },
            paddingBottom: function () {
              return 4;
            },
          },
        },
      ],
      styles: {
        title: {
          fontSize: 16,
          bold: true,
          color: "#01579b",
        },
        label: {
          bold: true,
          alignment: "right",
          color: "#333333",
        },
      },
    };

    var fileName = "debit-credit_" + (data.id || "") + "_" + momentJalai().format("jYYYY-jMM-jDD_HH-mm") + ".pdf";
    pdfMake.createPdf(docDefinition).download(fileName);
  }).catch(function () {});
};

export default generateDebitCreditPdf;
